module.exports = __webpack_public_path__ + "img/Perdues@3x.d397f02c.webp";